import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { userDeleteApi } from "modules/delete-user";
import { Success } from "components/success/success";
import { Error } from "components/error";
import { Spinner } from "components/spinner/spinner";
import i18n from "i18n";
import { language } from "index";
import { IEligibleToDeleteUserResponse } from "dto/responses/eligible-delete-user.dto";
import { IResponse } from "dto/shared";
import { runBasedOnCoutries } from "../../util";

export const Delete: React.FC = () => {
  const [isFinished, setIsFinished] = useState(false);
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  const countryCode = ["id", "en"];
  const deleteTokens = () => {
    window.sessionStorage.removeItem("access_token");
    window.sessionStorage.removeItem("refresh_token");
    window.sessionStorage.removeItem("scope");
  };

  const deleteUser = useCallback(() => {
    setIsFinished(false);
    setIsError(false);
    userDeleteApi
      .deleteCurrentUser()
      .then(() => {
        deleteTokens();
        setIsFinished(true);
      })
      .catch(() => {
        setIsError(true);
      });
  }, []);

  const checkIfEligibleToDelete = () => {
    userDeleteApi
      .eligibletoDeleteUser()
      .then((response: IResponse<IEligibleToDeleteUserResponse>) => {
        const isEligible =
          response.data &&
          response.data.eligible &&
          !response.data.hasContract &&
          !response.data.hasRELContract;
        if (isEligible) {
          if (runBasedOnCoutries(["id", "en"])) {
            navigate("/reason-delete");
          } else {
            deleteUser();
          }
        } else {
          navigate("/info-screen");
        }
        setIsFinished(true);
      })
      .catch(() => {
        setIsFinished(true);
        setIsError(true);
        navigate("/info-screen");
      });
  };

  useEffect(() => {
    setIsFinished(false);
    let token = window.sessionStorage.getItem("access_token");
    if (token === null) {
      setIsFinished(true);
      navigate("/");
    } else {
      if (runBasedOnCoutries(["id", "en"])) {
        checkIfEligibleToDelete();
      } else {
        deleteUser();
      }
    }
  // eslint-disable-next-line
  }, []);

  const handleReload = () => {
    if (runBasedOnCoutries(["id", "en"])) {
      navigate("/reason-delete");
    } else {
      deleteUser();
    }
  };

  return (
    <>
      {!isFinished && !isError && <Spinner />}
      {isFinished && <Success />}
      {isError && (
        <Error
          imagePath={
            countryCode?.includes(language as string) ? "/mascot_generic_error.svg" : "/error.svg"
          }
          header={i18n.t("SomethingWentWrong")}
          subheader={
            <React.Fragment>
              {i18n.t("UnableToRemove")}
              <br />
              {i18n.t("PleaseTryItAgain")}
            </React.Fragment>
          }
          btnAction={i18n.t("TryItAgain")}
          handleReload={handleReload}
        />
      )}
    </>
  );
};
